import React from 'react';
import { withTranslation } from 'react-i18next';

class SearchListTableComp extends React.Component {
    constructor(props) {
        super(props);

        this.clickRowItem = this.clickRowItem.bind(this);
    }

    clickRowItem(item) {
        const tableType = this.props.tableType;
        if (tableType == 'rbr') {
            window.location.href = wbConfig.baseUrl + '/rbr/index?id=' + item.id;
        }
        else if (tableType == 'kpi') {
            if (typeof window.openKpiViewModal === 'function') {
                window.openKpiViewModal(item.id, 'searchList');
            }
        }
        else {
            const type = item._type;
            let url = wbConfig.baseUrl;
            console.log('type', type);
            if(type == 'user'){
                url = url + "/memberProfile/index?id=" + item.id
                window.location.href = url;
            }
            else if (type == 'workstream') {
                url = url + "/activity/workstreams?id=" + item.id
                window.location.href = url;
            }
            else if (type == 'team') {
                url = url + "/activity/workstreams?teamView&teamId=" + item.id
                window.location.href = url;
            }
            else if (type == 'team_goal' || type == 'user_goal') {
                let params = (type == 'team_goal') ? 'teamId=' + item.id : 'userId=' + item.id;
                url = url + "/goal/teamGoal?js=1&" + params;
                window.location.href = url;
            }
            else if(type == 'user_metric' ){
                url = url + "/goal/getPersonKrs?id=" + item.encrId + '&refSrc=PERSON_KR';
                window.location.href = url;
            }
        }
    }

    renderHeader() {
        const { t } = this.props;
        const tableType = this.props.tableType;
        if (tableType == 'rbr') {
            return (
                <div className='searchlist-table-row searchlist-table-header-row'>
                    <div className='searchlist-table-col searchlist-table-title-col'>
                        {t('Biz Review Search Results')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-owner-col'>
                        {t('Owner')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-created-col'>
                        {t('Created')}
                    </div>
                    <div className='searchlist-table-col'>
                        {t('Status')}
                    </div>
                </div>
            );
        }
        else if (tableType == 'kpi') {
            return (
                <div className='searchlist-table-row searchlist-table-header-row'>
                    <div className='searchlist-table-col searchlist-table-title-col'>
                        {t('KPI Search Results')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-owner-col'>
                        {t('Owner')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-team-col'>
                        {t('Team')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-status-col'>
                        {t('Status')}
                    </div>
                </div>
            );
        }
        else if (tableType == 'other') {
            return (
                <div className='searchlist-table-row searchlist-table-header-row'>
                    <div className='searchlist-table-col searchlist-table-title-col'>
                        {t('Other Search Results')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-owner-col'>
                        {t('Owner')}
                    </div>
                    <div className='searchlist-table-col searchlist-table-status-col'>
                        {t('Status')}
                    </div>
                </div>
            );
        }
    }

    renderRows() {
        const tableType = this.props.tableType;
        const rows = this.props.rows || [];
        if (!rows.length) {
            return null;
        }
        if (tableType == 'rbr') {
            return rows.map((row, index) => this.renderRbrRow(row, index));
        }
        else if (tableType == 'kpi') {
            return rows.map((row, index) => this.renderKpiRow(row, index));
        }
        else if (tableType == 'other') {
            return rows.map((row, index) => this.renderOtherRow(row, index));
        }
    }

    renderRbrRow(row, index = 0) {
        const createdDate = (row.create_at > 0) ? moment(row.create_at * 1000).format('M/D/YY') : '';
        const statusText = (row.status == '3') ? 'Archived' : 'Unarchived';
        return (
            <div className='searchlist-table-row' 
                key={'rbr-list-page-' + row.id}
                >
                <div className='searchlist-table-col searchlist-table-title-col'>
                    <span className='title-text'  onClick={() => this.clickRowItem(row)}>
                        {row.description}
                    </span>
                </div>
                <div className='searchlist-table-col searchlist-table-owner-col'>
                    <div className='title-text'>
                        {row.owner_name}
                    </div>
                </div>
                <div className='searchlist-table-col searchlist-table-created-col'>
                    <div className='title-text'>
                        {createdDate}
                    </div>
                </div>
                <div className='searchlist-table-col searchlist-table-status-col'>
                    <div className='title-text'>
                        {statusText}
                    </div>
                </div>
            </div>
        );
    }

    renderKpiRow(row, index = 0) {
        const ownerName = Array.isArray(row.owner_names) ? row.owner_names.join(', ') : row.owner_name;
        const teamName = Array.isArray(row.team_names) ? row.team_names.join(', ') : row.team_name;
        const statusText = row.status === 'active' ? 'Active' : row.status === 'archived' ? 'Archived' : '';
        const kpiName = row.name || row.description;
        return (
            <div className='searchlist-table-row'
                key={'kpi-list-page-' + row.id}
                >
                <div className='searchlist-table-col searchlist-table-title-col'>
                    <span className='title-text' onClick={() => this.clickRowItem(row)}>
                        {kpiName}
                    </span>
                </div>
                <div className='searchlist-table-col searchlist-table-owner-col'>
                    <div className='title-text'>
                        {ownerName}
                    </div>
                </div>
                <div className='searchlist-table-col searchlist-table-team-col'>
                    <div className='title-text'>
                        {teamName || '-'}
                    </div>
                </div>
                <div className='searchlist-table-col searchlist-table-status-col'>
                    <div className='title-text'>
                        {statusText}
                    </div>
                </div>
            </div>
        );
    }

    renderOtherRow(row, index = 0) {
        const { t } = this.props;
        let statusText = '';
        const type = row._type;
        let description = row.description;
        if (type == 'workstream') {
            statusText = row.type == '0' ? 'Archived' : 'Unarchived'
            description = description + t(' Workstream');
        }
        else if (type == 'team') {
            description = description + t(' Team Page');
        }
        else if (type == 'user') {
            description = `${description}'s ${t('Profile Page')}`;
        }
        else if (type == 'team_goal' || type == 'user_goal') {
            description = `${description}'s ${t('OKRs')}`;
        }
        else if(type == 'user_metric'){
            description = `${description}'s ${t('Key Results')}`;
        }
        let ownerName = '';
        if (typeof row.owner_name !== 'undefined') {
            ownerName = row.owner_name;
        }
        let iconClass = '';
        if (type == 'workstream') {
            iconClass = 'icon-outline-waves-24px';
        }
        else if (type == 'team') {
            iconClass = 'icon-outline-people-24px_bluegreen';
        }
        else if (type == 'team_goal' || type == 'user_goal') {
            iconClass = 'icon-outline-bar_chart-24px-bluegreen';
        } 
        else if(type == 'user_metric'){
            iconClass = 'icon icon-kr-24px-bluegreen';
        }
        return (
            <div className='searchlist-table-row' 
                key={'other-list-page-' + type + '-' + row.id}
                >
                <div className='searchlist-table-col searchlist-table-title-col'>
                    <span className='title-text' onClick={() => this.clickRowItem(row)}>
                        <div className='other-list-icon'>
                        {
                            type == 'user' ?
                            <img src={row.picture} width="30" height="30" className='fitProfileImage roundFramePhoto' />
                            : <i className={'icon ' + iconClass} />
                        }
                        </div>
                       <div className='other-list-text'>{description}</div>
                    </span>
                </div>
                <div className='searchlist-table-col searchlist-table-owner-col'>
                    <div className='title-text'>
                        {ownerName}
                    </div>
                </div>
                <div className='searchlist-table-col searchlist-table-status-col'>
                    <div className='title-text'>
                        {statusText}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const wrapperClass = this.props.wrapperClass || '';
        return (
            <div className={'searchlist-table-wrapper ' + wrapperClass}>
                <div className='searchlist-table'>
                    { this.renderHeader() }
                    { this.renderRows() }
                </div>
            </div>
        )
    }
}

SearchListTableComp.defaultProps = {
    wrapperClass: '',
    tableType: '',
    rows: []
};

export default withTranslation()(SearchListTableComp);